<template>
  <StillImage
    v-if="url"
    class="-image"
    :class="{ '-wide': wide }"
    :src="url"
    :alt="name"
  />
  <UnicodeEmoji
    v-else
    :emoji="name"
  />
</template>

<script>
import StillImage from 'src/components/still-image/still-image.vue'
import UnicodeEmoji from 'src/components/unicode_emoji/unicode_emoji.vue'

import { useMergedConfigStore } from 'src/stores/merged_config.js'

// A reaction's emoji: a custom one as a still picture (paused like other
// GIFs, named by its code), else the unicode one. -wide when the setting
// allows wide emoji; the place it is shown decides what that means.
export default {
  name: 'ReactionEmoji',
  components: { StillImage, UnicodeEmoji },
  props: {
    name: { type: String, required: true },
    url: { type: String, default: null },
  },
  computed: {
    wide() {
      return !!useMergedConfigStore().mergedConfig.nonSquareEmoji
    },
  },
}
</script>
